import { render } from "./pop-up.vue?vue&type=template&id=47cc76a2&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"

import "./pop-up.vue?vue&type=style&index=0&id=47cc76a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47cc76a2"

export default script